angular.module('unica.basic_services')

.factory('authInterceptor', function($rootScope, AUTH_EVENTS, $q, $window, $location, Session, AWS_URL) {
	return {

		request: function(config) {
			config.headers = config.headers || {}; 
			// if ( Session.token && config.url.indexOf(AWS_URL) === -1 ) {
			// 	config.headers.Authorization = 'Bearer ' + Session.token;
			// }
			return config;
		},

		response: function(response) {
			return response || $q.when(response);
		}

	};
});
